import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/8mGMBFzUfDBa2mdC9g2ZRk/AVY_LOGO.png';
const NAV_ITEMS = [{
  label: 'Brief',
  href: '/brief'
}, {
  label: 'Ideas',
  href: '/'
}, {
  label: 'Henna',
  href: '/henna'
}, {
  label: 'Tattoo',
  href: '/tattoo'
}];
const ThreeDotIcon = () => <div className="flex flex-col items-center justify-center gap-[3px] w-5 h-5" data-id="element-11">
    <div className="w-[5px] h-[5px] bg-white rounded-full" data-id="element-12" />
    <div className="flex gap-[3px]" data-id="element-13">
      <div className="w-[5px] h-[5px] bg-white rounded-full" data-id="element-14" />
      <div className="w-[5px] h-[5px] bg-white rounded-full" data-id="element-15" />
    </div>
  </div>;
export function Navigation({
  activePath
}: {
  activePath: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <header className="p-4 md:p-6 no-print relative z-[80]" data-id="element-16">
      <div className="flex items-center justify-between gap-2" data-id="element-17">
        <div className="flex items-center gap-2" data-id="element-18">
          <div className="bg-white border border-black/10 rounded-full p-2 h-10 w-10 md:h-12 md:w-12 flex items-center justify-center shadow-sm" data-id="element-19">
            <img src={LOGO_URL} alt="Avy Logo" className="h-5 md:h-6 w-auto" data-id="element-20" />
          </div>
          {/* Desktop Nav */}
          <nav className="hidden lg:flex items-center gap-2" data-id="element-21">
            {NAV_ITEMS.map(item => <a key={item.href} href={item.href} className={`${activePath === item.href ? 'bg-primary text-black' : 'bg-white text-ink hover:bg-gray-50'} ${item.label === 'Ideas' ? '!text-black' : ''} border border-black/10 rounded-xl px-4 md:px-6 h-10 md:h-12 flex items-center text-xs md:text-sm font-bold shadow-sm transition-all`} data-id="element-22">
                {item.label}
              </a>)}
          </nav>
        </div>
        <div className="flex items-center gap-4" data-id="element-23">
          <span className="text-lg md:text-xl font-bold tracking-tighter text-ink" data-id="element-24">
            N Minhas
          </span>
          {/* Mobile Menu Toggle */}
          <button onClick={() => setIsOpen(!isOpen)} className="lg:hidden p-2 bg-ink border border-black/10 rounded-2xl shadow-lg text-white flex items-center justify-center w-12 h-12 relative z-[100]" aria-label="Toggle menu" data-id="element-25">
            <AnimatePresence mode="wait" initial={false} data-id="element-26">
              <motion.div key={isOpen ? 'close' : 'open'} initial={{
              opacity: 0
            }} animate={{
              opacity: 1
            }} exit={{
              opacity: 0
            }} transition={{
              duration: 0.2
            }} className="flex items-center justify-center" data-id="element-27">
                {isOpen ? <X size={24} className="text-white" data-id="element-28" /> : <ThreeDotIcon data-id="element-29" />}
              </motion.div>
            </AnimatePresence>
          </button>
        </div>
      </div>

      {/* Mobile Nav Overlay */}
      <AnimatePresence data-id="element-30">
        {isOpen && <>
            <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} onClick={() => setIsOpen(false)} className="fixed inset-0 bg-[#d9e2e8]/80 backdrop-blur-md lg:hidden z-[60]" data-id="element-31" />
            <motion.nav initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} transition={{
          duration: 0.4,
          ease: 'easeInOut'
        }} className="fixed inset-0 bg-black lg:hidden z-[70] p-4 pt-24 flex flex-col gap-3 overflow-y-auto" data-id="element-32">
              <div className="flex flex-col gap-3 flex-1" data-id="element-33">
                {NAV_ITEMS.map(item => <a key={item.href} href={item.href} onClick={() => setIsOpen(false)} className={`
                      relative group flex items-center p-8 rounded-[2rem] border transition-all duration-300
                      ${activePath === item.href ? 'bg-white border-white shadow-md' : 'bg-white/10 border-white/10 hover:border-white/20 shadow-sm'}
                    `} data-id="element-34">
                    <span className={`text-sm font-bold uppercase tracking-[0.2em] ${activePath === item.href ? 'text-black' : 'text-white'}`} data-id="element-35">
                      {item.label}
                    </span>
                  </a>)}
              </div>
              <div className="py-6 text-center" data-id="element-36">
                <p className="text-[10px] uppercase tracking-[0.2em] font-bold text-white/30" data-id="element-37">
                  N Minhas Brand Portal
                </p>
              </div>
            </motion.nav>
          </>}
      </AnimatePresence>
    </header>;
}